import {Button, MenuItem, TextareaAutosize} from '@material-ui/core';
import React, {useState} from 'react';
import Modal from 'Shared/components/Modal';
import OutlinedSelect from 'Shared/components/OutlinedSelect';
import {cancelExternalUploadQueue} from 'Enrollment/ducks/enrollmentFileProcessing';
import * as O from 'fp-ts/lib/Option';
import {useSelector, useDispatch} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {EnrollmentFileStatusType} from 'Enrollment/models/EnrollmentFileStatusType';
import './ExternalUploadQueueCancelConfirmationModal.sass';
import { isLoaded } from 'Core/models/Async';

export type ExternalUploadQueueRemoveConfirmationModalProps = {
  onClose: () => void;
  fileId: string;
  uploadedByEmail: string;
};

export enum ExternalUploadQueueRemovalOptionType {
  CompletedSeparately = 1,
  Duplicate = 2,
  FileErrorsPreventCompletion = 3,
  InvalidUpload = 4,
  PlanOptionNotMatch = 5,
}

const ExternalUploadQueueCancelConfirmationModal = (props: ExternalUploadQueueRemoveConfirmationModalProps) => {
  const {onClose} = props;
  const dispatch = useDispatch();
  const [selectedRemoveOptionId, setSelectedRemoveOptionId] = useState<O.Option<ExternalUploadQueueRemovalOptionType>>(
    O.none
  );

  const fileStatusId = EnrollmentFileStatusType.Returned;
  const {userClaims} = useSelector((state: ReducerState) => state.user.profile);

  const {externalUploadQueueFilters} = useSelector((state: ReducerState) => state.enrollmentFileProcessing);

  const handleEnrollmentFileRejectOptionChange = (value: ExternalUploadQueueRemovalOptionType) => {
    setSelectedRemoveOptionId(O.some(value));
  };
  const [getComments, setComments] = useState('');
  const defaultCharacterLength = 500;

  const disableRemoveButton = () => O.isNone(selectedRemoveOptionId);

  const handleRemoveEnrollmentApplication = () => {
    if (O.isSome(selectedRemoveOptionId)) {
      if(isLoaded(userClaims)){     
      dispatch(
        cancelExternalUploadQueue(
          props.fileId,
          fileStatusId,
          externalUploadQueueFilters,
          selectedRemoveOptionId.value,
          getComments,
          props.uploadedByEmail,
          userClaims.Data.firstName + ' ' + userClaims.Data.lastName,
        )
      );
        }
    }

    onClose();
  };

  return (
    <Modal open onClose={onClose} title="Return to Broker Reason">
      <div className="external-upload_cancel-comment-modal">
        <h4>Are you sure you would like to return this file to the broker?</h4>

        <OutlinedSelect
          className="external-upload_cancel-comment-modal__details"
          label="Reason for Return"
          onChange={e =>
            handleEnrollmentFileRejectOptionChange(parseInt(e.target.value, 10) as ExternalUploadQueueRemovalOptionType)
          }
          value={O.isSome(selectedRemoveOptionId) ? selectedRemoveOptionId.value : ''}
        >
          <MenuItem value={ExternalUploadQueueRemovalOptionType.CompletedSeparately}>Completed Separately</MenuItem>
          <MenuItem value={ExternalUploadQueueRemovalOptionType.Duplicate}>Duplicate</MenuItem>
          <MenuItem value={ExternalUploadQueueRemovalOptionType.FileErrorsPreventCompletion}>
            File Errors Prevent Completion
          </MenuItem>
          <MenuItem value={ExternalUploadQueueRemovalOptionType.InvalidUpload}>Invalid Upload</MenuItem>
          <MenuItem value={ExternalUploadQueueRemovalOptionType.PlanOptionNotMatch}>
            Plan option does not match available packages
          </MenuItem>
        </OutlinedSelect>

        <div className="external-upload_cancel-comment-modal__details">
          <TextareaAutosize
            rowsMax={10}
            rows={10}
            aria-label="maximum height"
            placeholder="Comments"
            value={getComments}
            onChange={e => setComments(e.target.value)}
            id="returned-comments"
            className="return-textarea-comments"
          />

          <p>
            Characters Left:{' '}
            {getComments.length > defaultCharacterLength ? 0 : defaultCharacterLength - getComments.length}
          </p>
        </div>

        <div className="modal__footer modal__footer-external-upload_cancel-comment">
          <Button
            className="modal__footer-external-upload_cancel-comment__actions"
            variant="contained"
            onClick={onClose}
          >
            Close
          </Button>

          <Button
            className="modal__footer-external-upload_cancel-comment__actions"
            color="primary"
            variant="contained"
            disabled={disableRemoveButton() || getComments.length > defaultCharacterLength || getComments.length == 0}
            onClick={handleRemoveEnrollmentApplication}
          >
            Return
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ExternalUploadQueueCancelConfirmationModal;
